import React from "react";
import { Helmet } from "react-helmet";

export default {
  jobCategories: {
    programming: "Programming",
    design: "Design",
    "customer-support": "Customer Support",
    "business-management": "Business & Management",
    "sales-marketing": "Sales & Marketing",
    product: "Product",
    "devops-systemadmin": "DevOps & System Admin",
    copywriting: "Copywriting",
    other: "Other",
  },
  blogPosts: [
    {
      title: "What is Remote Work?",
      summary:
        "Remote work is on the rise. How do people work remotely, why do they work remotely and what are some common misconceptions about remote work?",
      img:
        "https://res.cloudinary.com/svmszcck/image/upload/v1571990869/5bd22f40f39d992ca2bfeb64_What-is-Remote-Work_nsiieq.jpg",
      link: "https://remoteyear.com/blog/what-is-remote-work",
    },
    {
      title:
        "A Guide for Building Remote Teams and Finding Your Dream Work-from-Home Job",
      summary:
        "For anyone who’s ever dreamed of working from home or building a remote-first company, now is a great time to be alive.",
      img:
        "https://res.cloudinary.com/svmszcck/image/upload/v1571991602/shutterstock_1006574452-750x400_mptfg2.jpg",
      link: "https://open.buffer.com/remote-work",
    },
    {
      title: "Are we at the beginning of a remote working revolution?",
      summary:
        "Work performance is becoming a flexible on-demand service. And moreover, work is mediated via digital tools — in digital workspaces.",
      img:
        "https://res.cloudinary.com/svmszcck/image/upload/v1571993381/shutterstock_770015452-min_mb88om.jpg",
      link:
        "https://medium.com/@ennio_82854/are-we-at-the-beginning-of-a-remote-working-revolution-b0f26340c8a8",
    },
  ],
  metaTag: (
    <Helmet>
      <meta charSet="utf-8" />
      <title>
        Remote Jobs - Fully remote jobs in programming, design, marketing and
        more
      </title>
    </Helmet>
  ),
  googlePlayURL:
    "https://play.google.com/store/apps/details?id=com.quaxo.remotejobs",
  address: "Berlin, Germany",
  enterKey: "Enter",
  errors: {
    auth: "Please make sure you have filled all the fields correctly!",
    general: "An error occured. Please try again!",
  },
};
